import React, { useState, useEffect } from "react";
import {
  AppBar,
  Menu,
  MenuItem,
  Tabs,
  Tab,
  Toolbar,
  useMediaQuery,
  useTheme,
  ListItemIcon,
  Box,
  alpha,
  FormControl,
  InputLabel,
  Select,
  Stack,
} from "@mui/material";
import logo from "../Pages/images/Kurdish Translation Services.png";
import kurdish from "./Image/flag.png";
import english from "./Image/united-kingdom (2).png";
import { Link } from "react-router-dom";
import TranslateIcon from "@mui/icons-material/Translate";
import SubtitlesIcon from "@mui/icons-material/Subtitles";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DrawerComp from "./Drawer";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

const Navbar = () => {
  // Initialize value with a default value of 0 (first tab)
  const [value, setValue] = useState(0);
  // const [anchorEl, setAnchorEl] = useState(null); // State for language menu anchor
  const [servicesAnchorEl, setServicesAnchorEl] = useState(null); // State for services menu anchor
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));

  const [language, setLanguage] = useState("");
  const { t } = useTranslation();

  const onChangeLang = (e) => {
    const selectedLang = e.target.value;
    setLanguage(selectedLang);
    i18n.changeLanguage(selectedLang);
    // Save to localStorage (i18next standard key)
    localStorage.setItem("i18nextLng", selectedLang);
    // Also save to cookies for backward compatibility
    Cookies.set("language", selectedLang);
  };

  useEffect(() => {
    // Try to get language from localStorage first (i18next standard key)
    const savedLang =
      localStorage.getItem("i18nextLng") || Cookies.get("language");
    if (savedLang) {
      setLanguage(savedLang);
      i18n.changeLanguage(savedLang);
      // Sync to localStorage if it was only in cookies
      if (!localStorage.getItem("i18nextLng") && savedLang) {
        localStorage.setItem("i18nextLng", savedLang);
      }
    }
  }, []);

  // Handle language menu click
  // const handleLanguageClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // // Handle menu close
  // const handleLanguageClose = () => {
  //   setAnchorEl(null);
  // };

  // Handle services menu click
  const handleServicesClick = (event) => {
    setServicesAnchorEl(event.currentTarget); // Open the services menu
  };

  // Handle services menu close
  const handleServicesClose = () => {
    setServicesAnchorEl(null); // Close the services menu
  };

  // Helper component for displaying icons with labels
  const TabLabelWithIcon = ({ label }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      {label} <ArrowDropDownIcon />
    </div>
  );

  return (
    <React.Fragment>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.95) 100%)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          borderBottom: `1px solid ${alpha("#667eea", 0.15)}`,
          color: "text.primary",
          boxShadow: "0 4px 30px rgba(102, 126, 234, 0.08)",
          transition: "all 0.3s ease",
        }}
      >
        <Toolbar sx={{ py: { xs: 1, md: 1.5 } }}>
          {isMatch ? (
            <>
              <Box
                component={Link}
                to="/"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  cursor: "pointer",
                  "& img": {
                    height: { xs: 30, sm: 35 },
                    width: "auto",
                    maxWidth: { xs: 240, sm: 290 },
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                  },
                }}
              >
                <img src={logo} alt="Logo" />
              </Box>
              <Box
                sx={{
                  marginLeft: "auto",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <DrawerComp />
              </Box>
            </>
          ) : (
            <>
              <Box
                component={Link}
                to="/"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  cursor: "pointer",
                  "& img": {
                    height: 40,
                    width: "auto",
                    maxWidth: 300,
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                  },
                }}
              >
                <img src={logo} alt="Logo" />
              </Box>
              <Tabs
                sx={{
                  marginLeft: "auto",
                  "& .MuiTabs-indicator": {
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    height: 3,
                    borderRadius: "3px 3px 0 0",
                    boxShadow: "0 2px 8px rgba(102, 126, 234, 0.4)",
                  },
                }}
                value={value}
                onChange={(e, value) => setValue(value)}
              >
                <Tab
                  component={Link}
                  to="/"
                  label={t("Home")}
                  sx={{
                    fontWeight: 600,
                    fontSize: "0.95rem",
                    textTransform: "none",
                    minHeight: 64,
                    color: "text.primary",
                    transition: "all 0.3s ease",
                    borderRadius: 2,
                    mx: 0.5,
                    "&:hover": {
                      color: "#667eea",
                      background: alpha("#667eea", 0.08),
                      transform: "translateY(-2px)",
                    },
                    "&.Mui-selected": {
                      color: "#667eea",
                    },
                  }}
                />
                <Tab
                  label={<TabLabelWithIcon label={t("Server")} />}
                  onClick={handleServicesClick}
                  sx={{
                    fontWeight: 600,
                    fontSize: "0.95rem",
                    textTransform: "none",
                    minHeight: 64,
                    color: "text.primary",
                    transition: "all 0.3s ease",
                    borderRadius: 2,
                    mx: 0.5,
                    "&:hover": {
                      color: "#667eea",
                      background: alpha("#667eea", 0.08),
                      transform: "translateY(-2px)",
                    },
                  }}
                />
                <Tab
                  component={Link}
                  to="/ContactUs"
                  label={t("Contact")}
                  sx={{
                    fontWeight: 600,
                    fontSize: "0.95rem",
                    textTransform: "none",
                    minHeight: 64,
                    color: "text.primary",
                    transition: "all 0.3s ease",
                    borderRadius: 2,
                    mx: 0.5,
                    "&:hover": {
                      color: "#667eea",
                      background: alpha("#667eea", 0.08),
                      transform: "translateY(-2px)",
                    },
                    "&.Mui-selected": {
                      color: "#667eea",
                    },
                  }}
                />
                <Tab
                  component={Link}
                  to="/Book_now"
                  label={t("BookNow")}
                  sx={{
                    fontWeight: 600,
                    fontSize: "0.95rem",
                    textTransform: "none",
                    minHeight: 64,
                    color: "text.primary",
                    transition: "all 0.3s ease",
                    borderRadius: 2,
                    mx: 0.5,
                    "&:hover": {
                      color: "#667eea",
                      background: alpha("#667eea", 0.08),
                      transform: "translateY(-2px)",
                    },
                    "&.Mui-selected": {
                      color: "#667eea",
                    },
                  }}
                />
                <Tab
                  component={Link}
                  to="/AboutUs"
                  label={t("About")}
                  sx={{
                    fontWeight: 600,
                    fontSize: "0.95rem",
                    textTransform: "none",
                    minHeight: 64,
                    color: "text.primary",
                    transition: "all 0.3s ease",
                    borderRadius: 2,
                    mx: 0.5,
                    "&:hover": {
                      color: "#667eea",
                      background: alpha("#667eea", 0.08),
                      transform: "translateY(-2px)",
                    },
                    "&.Mui-selected": {
                      color: "#667eea",
                    },
                  }}
                />
              </Tabs>
              <Box sx={{ ml: 1, display: "flex", alignItems: "center" }}>
                <FormControl
                  sx={{
                    minWidth: 150,
                    maxWidth: 200,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      backgroundColor: alpha("#ffffff", 0.9),
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: alpha("#ffffff", 1),
                        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                      },
                      "&.Mui-focused": {
                        backgroundColor: alpha("#ffffff", 1),
                        boxShadow: "0 4px 16px rgba(102, 126, 234, 0.2)",
                      },
                      "& fieldset": {
                        borderColor: alpha("#667eea", 0.3),
                        transition: "all 0.3s ease",
                      },
                      "&:hover fieldset": {
                        borderColor: alpha("#667eea", 0.5),
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#667eea",
                        borderWidth: 2,
                      },
                    },
                    "& .MuiInputLabel-root": {
                      fontWeight: 600,
                      color: "text.primary",
                      fontSize: "0.875rem",
                      "&.Mui-focused": {
                        color: "#667eea",
                      },
                    },
                  }}
                  size="small"
                >
                  <InputLabel id="language-select-label-desktop">
                    {t("Lang")}
                  </InputLabel>
                  <Select
                    labelId="language-select-label-desktop"
                    id="language-select-desktop"
                    value={language || ""}
                    onChange={onChangeLang}
                    label={t("Lang")}
                    MenuProps={{
                      disableScrollLock: true,
                      MenuListProps: {
                        disablePadding: true,
                      },
                      PaperProps: {
                        elevation: 8,
                        sx: {
                          mt: 1,
                          borderRadius: 2,
                          background:
                            "linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.95) 100%)",
                          backdropFilter: "blur(20px)",
                          WebkitBackdropFilter: "blur(20px)",
                          border: `1px solid ${alpha("#667eea", 0.2)}`,
                          boxShadow: "0 8px 32px rgba(102, 126, 234, 0.15)",
                          position: "fixed",
                          "& .MuiMenuItem-root": {
                            px: 2,
                            py: 1.5,
                            borderRadius: 1.5,
                            mx: 0.5,
                            my: 0.25,
                            transition: "all 0.3s ease",
                            "&:hover": {
                              background:
                                "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
                              transform: "translateX(4px)",
                              boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                            },
                            "&.Mui-selected": {
                              background:
                                "linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)",
                              color: "#667eea",
                              fontWeight: 600,
                              "&:hover": {
                                background:
                                  "linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%)",
                              },
                            },
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="en">
                      <Stack
                        direction="row"
                        spacing={1.5}
                        alignItems="center"
                        sx={{ width: "100%" }}
                      >
                        <Box
                          component="img"
                          src={english}
                          alt="English Flag"
                          sx={{
                            width: 24,
                            height: 24,
                            objectFit: "cover",
                            borderRadius: "50%",
                            border: `2px solid ${alpha("#667eea", 0.2)}`,
                          }}
                        />
                        <Box
                          component="span"
                          sx={{
                            fontSize: "0.95rem",
                            fontWeight: 500,
                            color: "text.primary",
                          }}
                        >
                          {t("English")}
                        </Box>
                      </Stack>
                    </MenuItem>
                    <MenuItem value="ku">
                      <Stack
                        direction="row"
                        spacing={1.5}
                        alignItems="center"
                        sx={{ width: "100%" }}
                      >
                        <Box
                          component="img"
                          src={kurdish}
                          alt="Kurdish Flag"
                          sx={{
                            width: 24,
                            height: 24,
                            objectFit: "cover",
                            borderRadius: "50%",
                            border: `2px solid ${alpha("#667eea", 0.2)}`,
                          }}
                        />
                        <Box
                          component="span"
                          sx={{
                            fontSize: "0.95rem",
                            fontWeight: 500,
                            color: "text.primary",
                          }}
                        >
                          {t("Kurdish")}
                        </Box>
                      </Stack>
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>

              {/* Language Selection Menu */}
              {/* <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleLanguageClose}
              >
                <MenuItem
                  onClick={() => {
                    onChangeLang("en");
                    handleLanguageClose();
                  }}
                >
                  <ListItemIcon>
                    <img src={UK} alt="UK Flag" height={30} width={30} />
                  </ListItemIcon>
                  {t("English")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    onChangeLang("ku");
                    handleLanguageClose();
                  }}
                >
                  <ListItemIcon>
                    <img
                      src={Kurdstan}
                      alt="Kurdistan Flag"
                      height={25}
                      width={25}
                    />
                  </ListItemIcon>
                  {t("Kurdish")}
                </MenuItem>
              </Menu> */}

              {/* Services Selection Menu */}
              <Menu
                anchorEl={servicesAnchorEl}
                open={Boolean(servicesAnchorEl)}
                onClose={handleServicesClose}
                disableScrollLock={true}
                MenuListProps={{
                  disablePadding: true,
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    mt: 1.5,
                    borderRadius: 3,
                    minWidth: 220,
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.95) 100%)",
                    backdropFilter: "blur(20px)",
                    WebkitBackdropFilter: "blur(20px)",
                    border: `1px solid ${alpha("#667eea", 0.2)}`,
                    boxShadow: "0 8px 32px rgba(102, 126, 234, 0.15)",
                    overflow: "hidden",
                    position: "fixed",
                    "& .MuiMenuItem-root": {
                      px: 2.5,
                      py: 1.5,
                      borderRadius: 1.5,
                      mx: 1,
                      my: 0.5,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
                        color: "#667eea",
                        transform: "translateX(4px)",
                        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                      },
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                transitionDuration={300}
              >
                <MenuItem
                  component={Link}
                  to="/Translations"
                  onClick={handleServicesClose}
                >
                  <ListItemIcon>
                    <TranslateIcon sx={{ color: "#667eea", fontSize: 22 }} />
                  </ListItemIcon>
                  <Box sx={{ fontWeight: 600, fontSize: "0.95rem" }}>
                    {t("Translations")}
                  </Box>
                </MenuItem>

                <MenuItem
                  component={Link}
                  to="/Transcriptions"
                  onClick={handleServicesClose}
                >
                  <ListItemIcon>
                    <SubtitlesIcon sx={{ color: "#667eea", fontSize: 22 }} />
                  </ListItemIcon>
                  <Box sx={{ fontWeight: 600, fontSize: "0.95rem" }}>
                    {t("Transcriptions")}
                  </Box>
                </MenuItem>
                <MenuItem
                  component={Link}
                  to="/Interpreting"
                  onClick={handleServicesClose}
                >
                  <ListItemIcon>
                    <GTranslateIcon sx={{ color: "#667eea", fontSize: 22 }} />
                  </ListItemIcon>
                  <Box sx={{ fontWeight: 600, fontSize: "0.95rem" }}>
                    {t("Interpreting")}
                  </Box>
                </MenuItem>
              </Menu>
            </>
          )}
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

export default Navbar;
